import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types'
import { connect } from "react-redux";
import { IsLoggedInForFirstTime } from '../../../actions/authentication';
import jwt_decode from "jwt-decode";
import RightSidebar from '../../aside/RightSidebar';
import CommunityRightSidebar from '../../aside/CommunityRightSidebar'
import Header from '../../header/Header';
import Administration from './index';
import '../../../assets/css/layouts.css'
import Footer from '../../footer/Footer';
import NotFound from '../../../NotFound';
import { GlobalProvider } from '../../../context/GlobalContext';


class AdminLayout extends Component {
    constructor(props){
        super(props)
    }
    componentDidMount() {
        if ( !this.props.auth.isAuthenticated) {
            this.props.history.push("/login");
        }
        
        document.addEventListener('mouseup', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mouseup', this.handleClickOutside);
    }
    handleClickOutside(ev){
        ev.preventDefault();
        
        var CheckBoxes = document.querySelectorAll('.dropdowns .profil input[type="checkbox"], .dropdowns .notifs input[type="checkbox"], .rm-list input[type="checkbox"]');

        CheckBoxes.forEach(function(el, index){
            el.addEventListener('change', function(){
                CheckBoxes.forEach(function(currentItem, currentIndex){
                    if(el !== currentItem){
                        currentItem.checked = false;
                    }
                })

            });
        });

        var CheckboxesLabel = document.querySelectorAll('.rm-list .toggle, .dropdowns .profil label, .dropdowns .notifs label');
        var AtLeastOnClicked = false;
        CheckboxesLabel.forEach(function(el, index){
            if(el.contains(ev.target)){
                AtLeastOnClicked = true;
            }
        });
        if(!AtLeastOnClicked){
            CheckBoxes.forEach(function(currentItem, currentIndex){
                currentItem.checked = false;
            });
        }
    }
    
    render() {
        if (this.props.auth.isAuthenticated) {
            const decoded = jwt_decode(localStorage.jwtToken);
            this.props.IsLoggedInForFirstTime(decoded.username, this.props);
        }else{
            return "";
        }
        return (
            <div className="App" >
                 <GlobalProvider>
                    <Route path="/" component={Header} />
                 </GlobalProvider>
                <div className="section" id="_section">
                    <div className="max-width">
                        <div className="wrap">
                            <div className="d-flex jc-space-b section-layout">
                                {/* <Switch>
                                    <Route path="/communaute/:id" component={LeftSidebar} />
                                    <Route path="/" component={LeftSidebar} />
                                </Switch> */}
                                    
                                <Switch>
                                    <Route path="/administration" component={Administration} />
                                    <Route path="*" component={NotFound} />
                                </Switch>
                            
                                
                                {/* <Switch>
                                    <Route path="/communaute/:id" component={CommunityRightSidebar} />
                                    <Route path="/" component={RightSidebar} />
                                </Switch> */}
                            </div>
                        </div>
                    </div>
                </div>
                <Route path="/" component={Footer} />
            </div>
        )
    }
}


AdminLayout.propTypes = {
    IsLoggedInForFirstTime: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.errors,
});

export default connect(mapStateToProps, { IsLoggedInForFirstTime })(AdminLayout);